import type { ReceiptTemplate } from '../schema';

export const vrboTemplate: ReceiptTemplate = {
  id: 'vrbo',
  name: 'VRBO Receipt',
  brand: 'VRBO',
  description: 'VRBO vacation rental receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'vrbo-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'VRBO',
        businessNameFontSize: 22,
        addressLines: ['VACATION RENTAL RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'vrbo-booking',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'booking', label: 'Booking #:', value: 'VRBO-847291' },
          { id: 'guest', label: 'Guest:', value: 'John Doe' },
        ],
        column2: [
          { id: 'in', label: 'Check-In:', value: '01/02/2026' },
          { id: 'out', label: 'Check-Out:', value: '01/06/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'vrbo-property',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PROPERTY:\nBeachfront Condo #412\n1200 Dark Avenue\nMonsterville, CA 94608', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'vrbo-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'nightly', label: 'NIGHTLY RATE x 4', value: '600.00', isBold: false, isLarge: false },
          { id: 'cleaning', label: 'CLEANING FEE', value: '150.00', isBold: false, isLarge: false },
          { id: 'service', label: 'SERVICE FEE', value: '112.50', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '77.63', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '940.13', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'vrbo-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'vrbo-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'BOOKING CONFIRMED\n\nTHANK YOU FOR BOOKING', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

